module.exports = __webpack_public_path__ + "img/r.2edf7ae6.png";